export default __webpack_public_path__ + "static/media/pagination_left_arrow_disabled.27f7a6df.svg";